import React, { useEffect, useRef, useState } from 'react'
import Footer from '../footer';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import { Link } from 'react-router-dom';
import { viewlist } from '../../../api/BatchService';
import { fetchAnnualData, testList } from '../../../api/TestService';
import { formatDate, ToastMain ,SweetAlertShow} from '../../master/Master';
import { StudentList, StudentListt } from '../../../api/StudentServices';
import './print.css';
import { imgBaseUrl } from '../../../api/api';

const AnnualTest = () => {
  const [batch, setBatch] = useState();
  const [selectedBatch, setSelectedBatch] = useState("");
  const [List, setList] = useState([]);
  const [testListData, setTestListData] = useState('');
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('');
  const [batchStudents, setBatchStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectAllStudents, setSelectAllStudents] = useState(false);

  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
  const cardRefs = useRef([]);




  const fetchBatches = async () => {
    try {
      const response = await viewlist();
      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching batches");
    }
  };


  const fetchListDAta = async () => {
    let addUrl = `&batch_id=${selectedBatch}&student_id=${selectedStudent}`
    try {
      const response = await fetchAnnualData(addUrl);
      console.log('marksheet ka data', response?.data)
      if (response.data.status) {
        setList(response?.data?.data);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    }
  };

  const fetchStudents = async (batchId) => {
    try {
      const res = await StudentListt(`&batch_id=${batchId}`);
      if (res?.data?.status) {
        setBatchStudents(res.data.data || []); // <-- only keep array
      } else {
        alert("No students found for selected batch");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to load students");
    }
  };


  useEffect(() => {
    if (selectedBatch) {
      fetchStudents(selectedBatch);
    }
  }, [selectedBatch]);

  useEffect(() => {
    if (selectedBatch && selectedStudent) {
      fetchListDAta();
    }
  }, [selectedBatch, selectedStudent])

  useEffect(() => {
    fetchBatches();
  }, []);



  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid py-4">
                <div className="card mb-5">
                  <div className="card-body">
                    <Link to={`/progressCard`} className='btn btn-outline-primary me-3'>Batch Report</Link>
                    <Link to={`/annual/report`} className='btn btn-primary'>Annual Report</Link>
                  </div>
                </div>
                <div className="card shadow-sm border-0 p-4">
                  
                   <div className="d-flex justify-content-between align-items-center mb-4">
                   <h3 className="text-primary fw-bold mb-4">Annual Marks Report</h3>

                    <div className="d-flex gap-2">
                      <button className="btn btn-sm btn-primary">Test</button>
                      <button className="btn btn-sm btn-label-primary">Table</button>
                    </div>
                  </div>

                  <div className="row g-4">

                    <div className="col-md-4 form-floating form-floating-outline">

                      <select className="form-select" value={selectedBatch} onChange={(e) => setSelectedBatch(e.target.value)} >
                        <option value="">Select Batch</option>
                        {batch?.batches?.map((b) => (
                          <option key={b.id} value={b.id}>
                            {b.title}
                          </option>
                        ))}
                      </select>
                      <label>Batch</label>
                    </div>
                    <div className="col-md-4 form-floating form-floating-outline mb-1">
                      <select
                        className="form-select"
                        value={selectedStudent}
                        onChange={(e) => setSelectedStudent(e.target.value)}
                      >
                        <option value="">Select Student</option>
                        {batchStudents.length === 0 ? (
                          <option>No students found</option>
                        ) : (
                          batchStudents.map((student) => (
                            <option key={student.id} value={student.id}>
                              {student.name} - {student.registration_no}
                            </option>
                          ))
                        )}
                      </select>


                      <label>
                        Select Student <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-4 form-floating form-floating-outline mb-1">
                      <button className='btn btn-outline-primary' onClick={() => {
                        window.print()
                      }}>Print</button>
                    </div>

                  </div>

                </div>



                <div className="row mt-5">
                  {List?.test_marks?.map((testData, i) => {
                    const test = testData.test;

                    let grandTotal = 0;
                    let totalMax = 0;

                    return (
                      <div className="col-md-6 mb-4" key={i}>
                        <div ref={(el) => (cardRefs.current[i] = el)} className="print-area print-a4 card shadow">
                          <div className="card-body p-4">

                            {/* Header */}
                            <div className="text-center mb-4">
                              <img
                                src={
                                  instituteData?.logo_img
                                    ? `${imgBaseUrl+instituteData.logo_img}`
                                    : "/files/logo.png"
                                }
                                alt="School Logo"
                                style={{
                                  width: "10%",
                                  height: "10%",
                                  objectFit: "contain",
                                }}
                                className="rounded"
                              />

                              {/* PRINT BUTTON (WILL BE HIDDEN ON PRINT) */}
                              <div className="text-end">
                                {/* <button
                      className="print-hide btn btn-outline-primary"
                      onClick={() => window.print(i)}
                    >
                      Print
                    </button> */}
                              </div>

                              <h3 className="mb-0 fw-bold">{instituteData.name || "School Name"}</h3>
                              <p className="mb-0">
                                {instituteData.village},  {instituteData.district} ({instituteData.state})
                              </p>
                              <p className="mb-0">
                                📞 {instituteData.mobile}
                                {instituteData.secondary_mobile ? `, ${instituteData.secondary_mobile}` : ""}
                                , ✉️ {instituteData.email}
                              </p>
                              <h5 className="mt-3 text-primary">Progress Report Card ({formatDate(test.date)})</h5>
                              <h6 className="fw-bold text-dark">Test Name: {test.title}</h6>
                            </div>

                            {/* Student Info */}
                            <table className="table table-bordered mb-4">
                              <tbody>
                                <tr>
                                  <th>Student Name</th>
                                  <td>{List.student_info.name}</td>
                                  <th>Father's Name</th>
                                  <td>{List.student_info.father_name}</td>
                                </tr>
                                <tr>
                                  <th>Mother's Name</th>
                                  <td>{List.student_info.mother_name}</td>
                                  <th>DOB</th>
                                  <td>{List.student_info.dob}</td>
                                </tr>
                                <tr>
                                  <th>Class</th>
                                  <td>10TH ENG</td>
                                  <th>Roll No.</th>
                                  <td>{List.roll_number}</td>
                                </tr>
                                <tr>
                                  <th>S.R. No.</th>
                                  <td>{List.student_info.registration_no}</td>
                                  <th>Session</th>
                                  <td>2025–26</td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Marks Table */}
                            <div className="table-responsive mb-4">
                              <table className="table table-bordered text-center">
                                <thead className="table-light">
                                  <tr>
                                    <th>Subject</th>
                                    <th>Max Marks</th>
                                    <th>Marks Obtained</th>
                                    <th>Grade</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(test.subjects_detail) && test.subjects_detail.map((subject, index) => {
                                    const name = subject.name || `Subject ${index + 1}`;
                                    const max = parseInt(subject.marks || 0);
                                    const obtained = parseInt(subject.obtained_marks || 0);

                                    grandTotal += obtained;
                                    totalMax += max;

                                    const percent = (obtained / max) * 100;

                                    const getGrade = (p) => {
                                      if (p >= 91) return "A1";
                                      if (p >= 81) return "A2";
                                      if (p >= 71) return "B1";
                                      if (p >= 61) return "B2";
                                      if (p >= 51) return "C1";
                                      if (p >= 41) return "C2";
                                      if (p >= 33) return "D";
                                      return "E";
                                    };

                                    return (
                                      <tr key={index}>
                                        <td>{name}</td>
                                        <td>{max}</td>
                                        <td>{subject.obtained_marks !== null ? obtained : "-"}</td>
                                        <td>{subject.obtained_marks !== null ? getGrade(percent) : "-"}</td>
                                      </tr>
                                    );
                                  })}
                                  <tr className="fw-bold table-primary">
                                    <td>Grand Total</td>
                                    <td>{totalMax}</td>
                                    <td>{grandTotal}</td>
                                    <td>{totalMax > 0 ? ((grandTotal / totalMax) * 100).toFixed(2) + "%" : "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>



              </div>


              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
}

export default AnnualTest
